import {  inject, InjectionToken, provideAppInitializer, provideEnvironmentInitializer } from '@angular/core';
import { Amplify,  } from 'aws-amplify';
import { AmplifyAuthService, AuthService } from '../services/auth.service';
import { HttpInterceptorFn, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '../interceptors/interceptor.service';
import { cookieInterceptor } from '../interceptors/cookie.interceptor';

export const AUTH_PROVIDER_TOKEN = new InjectionToken<AuthService>('AuthProviderToken');

export function ProvideAuthProvider(cognitoUserPoolId: string, cognitoClientId: string, extraInterceptors: HttpInterceptorFn[] = []): any {
     const _initAmplify = (cognitoUserPoolId: string, cognitoClientId: string): void => 
          Amplify.configure({
                    Auth: {
                        Cognito: {
                            userPoolClientId: cognitoClientId,
                            userPoolId: cognitoUserPoolId ,
                        }
                }});

     _initAmplify(cognitoUserPoolId, cognitoClientId);
      /*function initializeApp(service: AuthService): () => Promise<any> {
            return async () => await service.init();
    }*/

     return [
         provideAppInitializer(() => inject(AuthService).init()),
        provideHttpClient(withInterceptors([authInterceptor, cookieInterceptor, ...extraInterceptors]), withFetch()),
         {provide: AuthService, useClass: AmplifyAuthService},
        //provideEnvironmentInitializer(() =>[ inject(AmplifyAuthService)])
    ];
        
}


